// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {openModal} from 'actions/views/modals';

import ModalToggleButtonRedux from './toggle_modal_button_redux.jsx';

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            openModal
        }, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(ModalToggleButtonRedux);



// WEBPACK FOOTER //
// ./components/toggle_modal_button_redux/index.js